import TemplateView from '../../../../TemplateView'
import {dayStatuses} from '../../constants'
import {getInstance as dayTooltip} from '../../../../SimpleSingletonTooltip'
import messageResource from '../../../../messageResource'
import {escapeHtmlSymbols} from '../../../../atUtils'

export default class Day extends TemplateView {
    constructor({
        additionalClass = '',
        date = null,
        nonWorking = false,
        onClick = () => {},
        editable = false,
    } = {}) {
        super()

        this.params = {
            additionalClass,
            date,
            nonWorking,
            editable,
        }

        this.callbacks = {
            onClick
        }

        this.state = {
            current: false,
            status: dayStatuses.STANDARD_DAY,
            title: '',
        }

        this.onStatePropertyChanged('current', () => this.$el.toggleClass('current', this.state.current))

        this.onStatePropertyChanged('status', () => {
            this.$el.toggleClass('nonWorking', this.params.nonWorking && this.state.status !== dayStatuses.NON_STANDARD_WORKING_DAY)
            this.$el.toggleClass('corporateHoliday', this.state.status === dayStatuses.CORPORATE_HOLIDAY)
            this._updateTooltip()
        })
    }

    templateHtml() {
        return "<div class='components_day <%-additionalClass%>'><%=dayNumber%></div>"
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
            dayNumber: this.params.date.getDate(),
        }
    }

    afterRender() {
        this.getEl().toggleClass('nonWorking', this.params.nonWorking)
        this.getEl().toggleClass('editable', this.params.editable)
        if (this.params.editable) {
            this.getEl().click(() => this.callbacks.onClick(this.$el, this.params.date, this.params.nonWorking, this.state.status, this.state.title))
        }

        this._updateTooltip()
    }

    _updateTooltip() {
        if (this.params.editable || this.state.status === dayStatuses.CORPORATE_HOLIDAY) {
            dayTooltip().subscribeToMouseEvents(this.getEl(), () => {
                dayTooltip().setState({
                    html: this._getDayTooltipHtml(),
                    extraClass: "calendarDayTooltip"
                })
            })
        }
    }

    _getDayTooltipHtml() {
        let tooltipText = messageResource.getMessage('work_schedule.working_day_txt')
        if (this.state.status === dayStatuses.CORPORATE_HOLIDAY)
            tooltipText = escapeHtmlSymbols(this.state.title)
        else if (this.params.nonWorking && this.state.status !== dayStatuses.NON_STANDARD_WORKING_DAY)
            tooltipText = messageResource.getMessage('work_schedule.nonworking_day_txt')
        let result = '<div class="dayStatus">' + tooltipText + '</div>'

        if (this.params.editable) {
            let tooltipNoteKey = 'work_schedule.click_to_edit'
            if (!this.params.nonWorking && this.state.status === dayStatuses.STANDARD_DAY)
                tooltipNoteKey = 'work_schedule.click_to_mark_as_holiday'

            result += '<div class="note">' + messageResource.getMessage(tooltipNoteKey) + '</div>'
        }
        return result
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/month/Day.js